export function formatAccountFields<T>(
  values: T[],
  requiredFields?: {
    field: keyof T;
    values: T[keyof T][];
    defaultValues?: Partial<T>;
  }
): T[] {
  const fieldsFormatted: T[] = [];

  values.forEach(item => {
    const result = {} as T;
    Object.keys(item).forEach(key => {
      if (key) {
        result[key] = item[key];
      }
    });
    fieldsFormatted.push(result);
  });

  requiredFields?.values?.forEach(value => {
    const { field, defaultValues } = requiredFields;

    const exists = fieldsFormatted.some(item => item[field] === value);

    if (!exists) {
      const result = {
        ...defaultValues,
        [field]: value
      } as T;
      fieldsFormatted.push(result);
    }
  });

  return fieldsFormatted;
}
